import React, { createContext, useState, useEffect } from "react";

export const NavContext = createContext();

const NavContextProvider = ({ children }) => {
  const [navData, setNavData] = useState({});

  useEffect(() => {
    fetch(`${window.location.origin}/navigations/navigations.json`)
      .then((response) => response.json())
      .then((data) => setNavData(data));

    return () => {
      setNavData({});
    };
  }, []);

  return (
    <NavContext.Provider value={{ navData }}>{children}</NavContext.Provider>
  );
};

export default NavContextProvider;
